/**
 * Sort the given object by its keys
 *
 * @param   {object} object
 * @returns {object}
 */
function objSort(object, recursive) {
    if (recursive === void 0) { recursive = true; }
    if (typeof object !== "object" || Array.isArray(object))
        return object;
    var sortedObject = {};
    var keys = Object.keys(object).sort();
    keys.forEach(function (key) {
        sortedObject[key] = recursive ? objSort(object[key]) : object[key];
    });
    return sortedObject;
}

export { objSort as default };
